/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Gladiator, GladiatorInterface } from "../Gladiator";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address payable",
        name: "relayerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
    ],
    name: "MetaTransactionExecuted",
    type: "event",
  },
  {
    inputs: [],
    name: "assetIsNFT",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assetName",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assetOperators",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "sigV",
        type: "uint8",
      },
    ],
    name: "executeMetaTransaction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "extendedProperties",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "value",
            type: "string",
          },
        ],
        internalType: "struct EnumerableStringMap.MapEntry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
    ],
    name: "getExtendedProperty",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
    ],
    name: "getProperty",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "idRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "image",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "inventory",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "image",
        type: "string",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "value",
            type: "bytes32",
          },
        ],
        internalType: "struct EnumerableMap.MapEntry[]",
        name: "properties",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "value",
            type: "string",
          },
        ],
        internalType: "struct EnumerableStringMap.MapEntry[]",
        name: "extendedProperties",
        type: "tuple[]",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "prestige",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "properties",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "value",
            type: "bytes32",
          },
        ],
        internalType: "struct EnumerableMap.MapEntry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "gladiator",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Gladiator__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Gladiator> {
    return super.deploy(assetsAddress, overrides || {}) as Promise<Gladiator>;
  }
  getDeployTransaction(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(assetsAddress, overrides || {});
  }
  attach(address: string): Gladiator {
    return super.attach(address) as Gladiator;
  }
  connect(signer: Signer): Gladiator__factory {
    return super.connect(signer) as Gladiator__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GladiatorInterface {
    return new utils.Interface(_abi) as GladiatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Gladiator {
    return new Contract(address, _abi, signerOrProvider) as Gladiator;
  }
}
